'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateMinWidgetHeight = calculateMinWidgetHeight;

var _dimensions = require('../constants/dimensions');

function calculateMinWidgetHeight(_ref) {
  var showCloseButton = _ref.showCloseButton;

  var minHeight = _dimensions.SMALLEST_WIDGET_HEIGHT + _dimensions.SPACING_ABOVE_WIDGET;
  if (showCloseButton) {
    minHeight += _dimensions.CLOSE_BUTTON_AND_SPACING;
  }

  return minHeight;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/widget-dimensions/util/calculateMinWidgetHeight.js
// module id = 1045
// module chunks = 2 3